import axios from 'axios'

export default {
  firmographicMetrics() {
    return axios
      .get('/api/metrics/firmographic_metrics', {
        handleErrors: true
      })
      .then(res => {
        return res.data
      })
  }
}
